import { getFirestore, doc, setDoc, getDoc, updateDoc, deleteDoc, collection, getDocs, onSnapshot } from "firebase/firestore";

const db = getFirestore();

class Fournisseur {
  constructor(name, numero, address, taxId, paymentTerms, restaurantId = null) {
    this.name = name;
    this.numero = numero;
    this.address = address;
    this.taxId = taxId;
    this.paymentTerms = paymentTerms;
    this.restaurantId = restaurantId;
    this.id = null;
  }

  // Add a new fournisseur - méthode d'instance
  async addFournisseur() {
    try {
      const fournisseurRef = doc(collection(db, "fournisseurs"));
      await setDoc(fournisseurRef, {
        name: this.name,
        numero: this.numero,
        address: this.address || "",
        taxId: this.taxId || "",
        paymentTerms: this.paymentTerms || "30_days",
        restaurantId: this.restaurantId,
      });
      this.id = fournisseurRef.id;
      return this.id;
    } catch (error) {
      console.error("Error adding fournisseur:", error.message);
      throw new Error(error.message);
    }
  }

  // Méthode statique pour ajouter un fournisseur (utilisée par votre composant)
  static async addFournisseur(restaurantId, fournisseurData) {
    try {
      const fournisseurRef = doc(collection(db, "fournisseurs"));
      await setDoc(fournisseurRef, {
        name: fournisseurData.name,
        numero: fournisseurData.numero,
        address: fournisseurData.address || "",
        taxId: fournisseurData.taxId || "",
        paymentTerms: fournisseurData.paymentTerms || "30_days",
        restaurantId: restaurantId,
      });
      return fournisseurRef.id;
    } catch (error) {
      console.error("Error adding fournisseur:", error.message);
      throw new Error(error.message);
    }
  }

  // Update fournisseur
  static async updateFournisseur(restaurantId, fournisseurId, updates) {
    try {
      const fournisseurRef = doc(db, "fournisseurs", fournisseurId);
      await updateDoc(fournisseurRef, updates);
    } catch (error) {
      console.error("Error updating fournisseur:", error.message);
      throw new Error(error.message);
    }
  }

  // Get all fournisseurs (one-time fetch), optionally filtered by restaurantId
  static async getAllFournisseurs(restaurantId = null) {
    try {
      const fournisseursCollection = collection(db, "fournisseurs");
      const snapshot = await getDocs(fournisseursCollection);
      const fournisseurs = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((fournisseur) => {
          return restaurantId ? fournisseur.restaurantId === restaurantId : false;
        });
      return fournisseurs;
    } catch (error) {
      console.error("Error retrieving fournisseurs:", error.message);
      throw new Error(error.message);
    }
  }

  // Real-time updates for fournisseurs
  static listenFournisseurs(callback, restaurantId = null) {
    try {
      const fournisseursCollection = collection(db, "fournisseurs");
      return onSnapshot(fournisseursCollection, (snapshot) => {
        const fournisseurs = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((fournisseur) => !restaurantId || fournisseur.restaurantId === restaurantId);
        callback(fournisseurs);
      });
    } catch (error) {
      console.error("Error listening to fournisseurs:", error.message);
      throw new Error(error.message);
    }
  }

  // Delete fournisseur
  static async deleteFournisseur(restaurantId, fournisseurId) {
    try {
      const fournisseurRef = doc(db, "fournisseurs", fournisseurId);
      await deleteDoc(fournisseurRef);
    } catch (error) {
      console.error("Error deleting fournisseur:", error.message);
      throw new Error(error.message);
    }
  }

  // Get fournisseur by ID
  static async getFournisseurById(id) {
    try {
      const fournisseurRef = doc(db, "fournisseurs", id);
      const docSnap = await getDoc(fournisseurRef);
      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      } else {
        throw new Error("Fournisseur not found");
      }
    } catch (error) {
      console.error("Error fetching fournisseur by ID:", error.message);
      throw new Error(error.message);
    }
  }
}

export default Fournisseur;